import BreadcrumbGroup, { BreadcrumbGroupProps } from "@amzn/awsui-components-react/polaris/breadcrumb-group";
import { JSX } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Props for the NavigationBreadcrumbs component
 *
 * @interface
 * @property {Array<{ text: string; href: string }>} items - represents the structure for the breadcrumbs
 *                                                           the text is the name of the page
 *                                                           the href is the link to it
 */
interface NavigationBreadcrumbsProps {
    items: { text: string; href: string }[];
}

/**
 * Custom function to return the navigation breadcrumbs configured
 *
 * @param {NavigationBreadcrumbsProps} items - represents the structure for the breadcrumbs
 */
const NavigationBreadcrumbs = ({ items }: NavigationBreadcrumbsProps): JSX.Element => {
    const navigate = useNavigate();

    function onFollowHandler(event: CustomEvent<BreadcrumbGroupProps.Item>) {
        event.preventDefault();
        if (event.detail.href) {
            navigate(event.detail.href);
        }
    }

    return <BreadcrumbGroup items={items} onFollow={onFollowHandler} />;
};

export default NavigationBreadcrumbs;
